const prefix = "DAAT_profile_added";

const LOCAL_STORAGE_KEYS = {
  PROFILE_LANGUAGE: `${prefix}.profile_language`,
  THEME: `${prefix}.theme`,
};

export default LOCAL_STORAGE_KEYS;
